/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EPublicCloudRestoreType {
    RestoreVmInstance = 'restoreVmInstance',
    RestoreVmVolume = 'restoreVmVolume',
    RestoreVmFileLevel = 'restoreVmFileLevel',
    RestoreEfsEntire = 'restoreEfsEntire',
    RestoreEfsFileLevel = 'restoreEfsFileLevel',
    RestoreRds = 'restoreRds',
    RestoreRdsDbLevel = 'restoreRdsDbLevel'
};

